import * as React from "react";
import Link from "next/link";
import Image from "next/image";
import {
  useECMAExperience,
  useJMMGExperience,
  usePoFExperience,
  useSJMGExperience,
  useUMPExperience,
} from "@common/hooks";
import pofMobile from "@logos/pof-logo-mobile.png";
import umpMobile from "@logos/ump-logo-mobile.png";
import jmmgMobile from "@logos/jmmg-logo-mobile.png";
import ecmaMobile from "@logos/ecma-logo-mobile.png";
import sjmgMobile from "@logos/sjmg-logo-mobile.png";
import Earned from "@logos/earned.svg";
import cx from "classnames";

const LogoHeader: React.FC = () => {
  const { isPof } = usePoFExperience();
  const { isUMPExperience } = useUMPExperience();
  const { isJMMGExperience } = useJMMGExperience();
  const { isECMAExperience } = useECMAExperience();
  const { isSJMGExperience } = useSJMGExperience();
  return (
    <>
      <Link href="/" className={cx("flex", !isPof && "pt-2")}>
        <span className="sr-only">Earned Wealth</span>
        {isPof ? (
          <Image src={pofMobile} alt="earned logo" width={235} height={40} />
        ) : isUMPExperience ? (
          <Image src={umpMobile} alt="earned logo" width={225} height={42} />
        ) : isJMMGExperience ? (
          <Image src={jmmgMobile} alt="earned logo" width={225} height={42} />
        ) : isECMAExperience ? (
          <Image src={ecmaMobile} alt="earned logo" width={225} height={42} />
        ) : isSJMGExperience ? (
          <Image src={sjmgMobile} alt="earned logo" width={225} height={42} />
        ) : (
          <Image src={Earned} alt="earned logo" width={100} height={72} />
        )}
      </Link>
    </>
  );
};

export default LogoHeader;
